import AcademyService from '@/api/AcademyService.js'
import Vue from 'vue'
export const academyModule = {
  namespaced: true,
  state: () => ({
    AcademyData: [],
    AcademyLoadStatus: 'request',
    paginationAcademyStateParams: {
      count: 0,
      limit: 5,
      total: 0,
      page: 0
    }
  }),

  getters: {
    numPages: (state) =>
      Math.ceil(
        state.paginationAcademyStateParams.total /
        state.paginationAcademyStateParams.limit
      )
  },
  mutations: {
    get_all(state, data) {
      state.AcademyData = [...data]
    },
    create(state, data) {
      state.AcademyData.unshift(data[0])
    },
    edit_multiple(state, data) {
      let indexed = state.AcademyData.findIndex((x) => x.docs__id == data.id)
      Object.assign(state.AcademyData[indexed], data.dataEdit)
    },

    delete_data(state, id) {
      let indexed = state.AcademyData.findIndex((x) => x.docs__id == id)
      state.AcademyData.splice(indexed, 1)
    },

    update_pagination(state, { total, count, limit, page }) {
      state.paginationAcademyStateParams = { total, count, limit, page }
    },

    load_request(state, status) {
      state.AcademyLoadStatus = 'request'
    },
    load_success(state) {
      state.AcademyLoadStatus = 'success'
    },
    load_error(state) {
      state.AcademyLoadStatus = 'error'
    }
  },
  actions: {
    getAcademyAll({ commit }, params) {
      commit('load_request')

      AcademyService.getAll(params)
        .then((data) => {
          commit('update_pagination', data.data.data)
          commit('get_all', data.data.data.rows)
          commit('load_success')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
          commit('load_error')
        })
    },

    createAcademyData({ commit }, createData) {
      AcademyService.create(createData)
        .then((data) => {
          commit('create', data.data.data.rows)
          Vue.$toast.success('Запись добавлена')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    },

    editAcademyMultiple({ commit }, { id, dataEdit }) {
      AcademyService.editMultiple(id, dataEdit)
        .then((data) => {
          commit('edit_multiple', { id, dataEdit })
          Vue.$toast.success('Данные успешно обновлены')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    },

    deleteAcademyData({ commit }, id) {
      // commit("load_request");
      AcademyService.delete(id)
        .then((data) => {
          commit('delete_data', id)
          Vue.$toast.success('Данные успешно удалены')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    }
  }
}
